import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Framework from "@/pages/Framework";
import PublishedWork from "@/pages/PublishedWork";
import BookPage from "@/pages/BookPage";
import Steppers from "@/pages/Steppers";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollToTop />
            <div className="flex min-h-screen flex-col bg-white">
                <Header />
                <div className="flex-1">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/framework" element={<Framework />} />
                        <Route path="/published-work" element={<PublishedWork />} />
                        <Route path="/published-work/breaking-the-chains" element={<BookPage />} />
                        <Route path="/11th-steppers" element={<Steppers />} />
                        <Route path="/resources" element={<Resources />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </div>
                <Footer />
            </div>
            <Toaster position="bottom-center" richColors />
        </BrowserRouter>
    );
}

export default App;
